module.exports = __webpack_public_path__ + "img/0357c5dd845c6c292e80e5f3dd8013c5.82a89cfc.jpg";